/**
 * ceracica-product.js — iaware BEAUTY
 */
(function(){'use strict';
document.addEventListener('DOMContentLoaded',init);
function init(){renderJsonMetafields();bindVariantSelects();bindAddToCart();}
function renderJsonMetafields(){
  var el=document.getElementById('ceracica-ingredients');
  if(el){try{var d=JSON.parse(el.dataset.json||'[]');if(Array.isArray(d)&&d.length){el.innerHTML=d.map(function(i){return'<div class="ceracica-ingredient"><div class="ceracica-ingredient__name">'+esc(i.name)+'<\/div><div class="ceracica-ingredient__role">'+esc(i.role)+'<\/div><\/div>';}).join('');}}catch(e){}}
  var how=document.getElementById('ceracica-how');
  if(how){try{var s=JSON.parse(how.dataset.json||'[]');if(Array.isArray(s)&&s.length){how.innerHTML=s.map(function(t,i){return'<div class="ceracica-how__step"><div class="ceracica-how__num">'+(i+1)+'<\/div><div class="ceracica-how__text">'+esc(t)+'<\/div><\/div>';}).join('');}}catch(e){}}
  var tags=document.getElementById('ceracica-skin-tags');
  if(tags){try{var a=JSON.parse(tags.dataset.json||'[]');if(Array.isArray(a)&&a.length){tags.innerHTML=a.map(function(t){return'<span class="ceracica-skin-tag">'+esc(t)+'<\/span>';}).join('');}}catch(e){}}
}
function bindVariantSelects(){
  var sels=document.querySelectorAll('.ceracica-form__select[data-option-index]');
  if(!sels.length)return;
  sels.forEach(function(sel){sel.addEventListener('change',onVariantChange);});
}
function onVariantChange(){
  var variants=(window.cerProductData||{}).variants||[];
  if(!variants.length)return;
  var sels=document.querySelectorAll('.ceracica-form__select[data-option-index]');
  var opts=[];sels.forEach(function(s){opts.push(s.value);});
  var matched=variants.find(function(v){return v.options.every(function(o,i){return o===opts[i];});});
  if(!matched)return;
  var id=document.getElementById('ceracica-variant-id');if(id)id.value=matched.id;
  var price=document.getElementById('ceracica-price');if(price){price.textContent='$'+(matched.price/100).toFixed(2);}
  var btn=document.getElementById('ceracica-add-to-cart');
  if(btn){if(matched.available){btn.disabled=false;btn.textContent=btn.dataset.defaultText||'Add to Bag';}else{btn.disabled=true;btn.textContent='Sold Out';}}
  if(matched.featured_image){var img=document.getElementById('ceracica-featured-img');if(img){img.src=matched.featured_image.src;img.alt=matched.featured_image.alt||'';}}
}
window.cerQtyChange=function(delta){
  var inp=document.getElementById('ceracica-qty');if(!inp)return;
  var v=parseInt(inp.value,10)||1;
  inp.value=Math.min(parseInt(inp.max,10)||99,Math.max(parseInt(inp.min,10)||1,v+delta));
};
function bindAddToCart(){
  var form=document.getElementById('ceracica-product-form');if(!form)return;
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=document.getElementById('ceracica-add-to-cart');
    if(!btn||btn.disabled)return;
    var dt=btn.textContent.trim();btn.dataset.defaultText=dt;btn.disabled=true;btn.textContent='Adding...';
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'X-Requested-With':'XMLHttpRequest'}})
    .then(function(r){if(!r.ok)throw new Error(r.status);return r.json();})
    .then(function(){btn.textContent='Added!';btn.style.background='#8FA68B';document.dispatchEvent(new CustomEvent('cart:refresh'));setTimeout(function(){btn.disabled=false;btn.textContent=dt;btn.style.background='';},2200);})
    .catch(function(){btn.disabled=false;btn.textContent=dt;alert('Could not add to cart. Please try again.');});
  });
}
window.cerProductThumb=function(el){
  if(!el)return;
  var img=document.getElementById('ceracica-featured-img');
  if(img){img.src=el.dataset.src;img.alt=el.dataset.alt||'';}
  document.querySelectorAll('.ceracica-product__thumb').forEach(function(t){t.classList.remove('is-active');});
  el.classList.add('is-active');
};
window.cerToggleAcc=function(trigger){
  var expanded=trigger.getAttribute('aria-expanded')==='true';
  var body=document.getElementById(trigger.getAttribute('aria-controls'));
  if(!body)return;
  trigger.setAttribute('aria-expanded',String(!expanded));
  body.classList.toggle('is-open',!expanded);
};
function esc(str){return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
})();
/* PDP 호버 스왑: 메인 이미지에 마우스 올리면 2번째 이미지(숫자)로 */
(function () {
  function initCcHover() {
    document.querySelectorAll('.ceracica-product').forEach(function (p) {
      var thumbs = p.querySelectorAll('.ceracica-product__thumbs img');
      var feat = p.querySelector('#ceracica-featured-img') || p.querySelector('.ceracica-product__image-wrap img');
      var wrap = p.querySelector('.ceracica-product__image-wrap');
      if (!feat || !wrap || thumbs.length < 2) return;
      var baseSrc = feat.getAttribute('src');
      var baseSet = feat.getAttribute('srcset') || '';
      var hoverSrc = thumbs[1].getAttribute('src');
      wrap.addEventListener('mouseenter', function () { feat.setAttribute('srcset',''); feat.setAttribute('src', hoverSrc); });
      wrap.addEventListener('mouseleave', function () { feat.setAttribute('srcset', baseSet); feat.setAttribute('src', baseSrc); });
    });
  }
  if (document.readyState !== 'loading') initCcHover();
  else document.addEventListener('DOMContentLoaded', initCcHover);
})();